/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does the downloaded image have a transparent background?`)
};

const es_sig_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿La imagen descargada tiene un fondo transparente?`)
};

const de_sig_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat das heruntergeladene Bild einen transparenten Hintergrund?`)
};

const nl_sig_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heeft de gedownloade afbeelding een transparante achtergrond?`)
};

const fr_sig_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'image téléchargée a-t-elle un arrière-plan transparent?`)
};

const it_sig_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'immagine scaricata ha uno sfondo trasparente?`)
};

const pt_br2_sig_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A imagem baixada tem um fundo transparente?`)
};

const pt_sig_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A imagem descarregada tem fundo transparente?`)
};

const ja_sig_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダウンロードした画像は透明な背景ですか?`)
};

const zh_sig_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载的图像有透明背景吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_hub_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_hub_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_hub_faq2_q", locale)
	if (locale === "en") return en_sig_hub_faq2_q(inputs)
	if (locale === "es") return es_sig_hub_faq2_q(inputs)
	if (locale === "de") return de_sig_hub_faq2_q(inputs)
	if (locale === "nl") return nl_sig_hub_faq2_q(inputs)
	if (locale === "fr") return fr_sig_hub_faq2_q(inputs)
	if (locale === "it") return it_sig_hub_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_sig_hub_faq2_q(inputs)
	if (locale === "pt") return pt_sig_hub_faq2_q(inputs)
	if (locale === "ja") return ja_sig_hub_faq2_q(inputs)
	return zh_sig_hub_faq2_q(inputs)
};